<template>
	<div class="infor fl">
		<div class="infor-t clearfix">
			<div class="fl infor-t-l">{{lable}}</div>
			<div class="fr infor-t-r" @click="onReadTap">
				<img src="../assets/yan.png" alt="" />
				<span>一键已读</span>
			</div>
		</div>

		<div class="wrap">
			<div v-for="(item,index) in list" :key="index" class="wrap-item">
				<div class="wrap-item-l">
					<span v-if="!item.read_at&&!isRead" class="wrap-item-l-s">新</span>
					<p class="wrap-item-l-p" :class="!item.read_at&&!isRead?'font-main':'font-assist'">
						{{item.title}}
					</p>
				</div>
				<div class="wrap-item-r">

					<p>{{item.created_at}}</p>
				</div>
			</div>
		</div>
		<Pagetion :total="total" @getpageValue="getpageValue" class="pos-page" />
	</div>
</template>

<script>
	// import AllHeader from "@/components/Modal/AllHeader";
	import Pagetion from "@/components/Modal/Pagetion";
	import {
		Message,
		MessageRead //一键已读
	} from "../utils/api.js"
	export default {
		name: "news",
		components: {
			// AllHeader,
			Pagetion
		},
		data() {
			return {
				img: '../../assets/yan.png',
				sublabel: '一键已读',
				isRead:false,//是否阅读
				lable: '',
				total: 0,
				list: []
			}
		},
		mounted() {
			this.lable = this.$route.query.name;
			this.initList(1)
		},
		methods: {
			// 日期格式转换
			rTime(date) {
				var json_date = new Date(date).toJSON();
				return new Date(new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
					/\.[\d]{3}Z/, '')
			},

			initList(page) {
				const data = {
					page_size: 10,
					page: page,
				}
				Message(data).then(res => {
					if (res.data.length) {
						// res.data.map(item => {
						// 	item.created_at = this.rTime(item.created_at)
						// })
						this.list = res.data
						this.total = res.total
					}

				})
			},
			// 一键已读
			onReadTap() {
				const data={
					ids:''
				}
				MessageRead(data).then(res => {
					console.log(res)
					this.isRead=true
				})
			},
			getpageValue(index) {
				console.log(index)
				this.initList(index)
			},
			changeinfo() {
				this.ischage = false;
				this.title = '修改基本资料'
			}
		}
	}
</script>

<style lang="less" scoped>
	.infor {


		&-t {
			// padding: 14px;
			padding-top: 14px;
			border-bottom: 1px solid #194ABE;

			&-l {
				font-size: 28px;
				color: #181e23;
				display: inline-block;
				padding-bottom: 14px;
				font-weight: bold;
				border-bottom: 2px solid #194abe;
			}

			&-r {
				width: 124px;
				height: 36px;
				background: #ffffff;
				border: 1px solid #194ABE;
				opacity: 1;
				overflow: hidden;
				display: table-cell;
				line-height: 31px;
				border-radius: 6px;
				cursor: pointer;

				img {
					vertical-align: middle;
					margin-right: 6px;
				}

				span {
					color: #194ABE;
					font-size: 14px;
				}
			}
		}

		&-c {
			text-align: justify;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 32px;
			color: #565656;
			padding: 10px 0px;
		}

		&-img {
			text-align: center;
			padding: 24px 0px 40px 0px;
		}
	}

	.wrap {
		&-item {
			padding: 28px 0px;
			border-bottom: 1px dashed #C8CDD5;
			display: flex;
			justify-content: space-between;
			align-items: center;

			&-l {
				width: 70%;
				display: flex;
				align-items: center;

				&-p {
					width: 90%;
					text-align: left;
				}

				&-s {
					width: 31px;
					height: 23px;
					background: #E51725;
					opacity: 1;
					border-radius: 14px;
					font-size: 16px;
					color: #FFFFFF;
					margin-right: 20px;
				}

			}

			&-r {
				color: #9FA5AE;

			}

		}
	}

	.font-assist {
		color: #7C828A;
	}

	.font-main {
		color: #0C0D0F;
	}
</style>
